import React from "react";

/**
 * @param {object} props
 * @param {string} [props.message]
 * @param {boolean} [props.fullPage]
 * @param {"sm"|"md"|"lg"} [props.size]
 * @param {string} [props.className]
 */
export default function Loader({
  message = "Loading...",
  fullPage = false,
  size = "md",
  className = "",
}) {
  const rootClass = [
    "app-loader",
    fullPage ? "app-loader--full" : "",
    `app-loader--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass} role="status" aria-live="polite" aria-busy="true">
      <div className="app-loader__visual" aria-hidden="true">
        <div className="app-loader__ring" />
        <div className="app-loader__core">
          <span />
          <span />
          <span />
        </div>
      </div>
      {message ? <p className="app-loader__text">{message}</p> : null}
      <span className="visually-hidden">{message || "Loading"}</span>
    </div>
  );
}

export function ButtonSpinner() {
  return <span className="app-loader__btn-spin" aria-hidden="true" />;
}
